export default __webpack_public_path__ + "static/media/blog_inner_22.f51e9eb1.png";